import { render, staticRenderFns } from "./QuantityLocation.vue?vue&type=template&id=0bb5429f"
import script from "./QuantityLocation.vue?vue&type=script&lang=js"
export * from "./QuantityLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports